import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ApsPermitedScreen } from '../../models/aps-permission/aps-permited-screen';
import { AdditionalInformationPagarMe } from '../../models/pagar-me/additional-information-pagar-me';
import { AddressPagarMe } from '../../models/pagar-me/address-pagar-me';
import { BillingAddressPagarMe } from '../../models/pagar-me/billing-address-pagar-me';
import { CardPagarMe } from '../../models/pagar-me/card-pagar-me';
import { CreditCardPagarMe } from '../../models/pagar-me/credit-card-pagar-me';
import { CustomerPagarMe } from '../../models/pagar-me/customer-pagar-me';
import { DebitCardPagarMe } from '../../models/pagar-me/debit-card-pagar-me';
import { ItemPagarMe } from '../../models/pagar-me/item-pagar-me';
import { MobilePhonePagarMe } from '../../models/pagar-me/mobile-phone-pagar-me';
import { OrdersPagarMe } from '../../models/pagar-me/orders-pagar-me';
import { PaymentPagarMe } from '../../models/pagar-me/payment-pagar-me';
import { PhonesPagarMe } from '../../models/pagar-me/phones-pagar-me';
import { PixPagarMe } from '../../models/pagar-me/pix-pagar-me';
import { ChargePagarMeResponse } from '../../models/pagar-me/response/charges-pagar-me-response';
import { OrdersPagarMeResponsePix } from '../../models/pagar-me/response/orders-pagar-me-response.pix';
import { ApsPermissionService } from '../../services/aps-permission/aps-permission.service';
import { OrdersPagarMeService } from '../../services/orders-pagar-me/orders-pagar-me.service';

@Component({
    selector: 'app-import-contract',
    templateUrl: './import-contract.component.html',
	styleUrls: ['./import-contract.component.scss'],
    standalone: false
})
export class ImportContractComponent implements OnInit {
	private readonly destroyRef = inject(DestroyRef);

	uploadedFiles: File[] = [];
	showProgressBar = false;
	userform!: UntypedFormGroup;
	cardPagarMeCredit: CardPagarMe;
	cardPagarMeDebit: CardPagarMe;	
	itemPagarMe: ItemPagarMe;
	ordersPagarMe: OrdersPagarMe = new OrdersPagarMe();
	cards: CardPagarMe[] = [];
	dataCard: string[] = [];
	CREDIT_CARD = "credit_card";
	DEBIT_CARD = "debit_card";
	PIX = "pix";
	ordersPagarMeResponsePix: OrdersPagarMeResponsePix;

	constructor(private messageService: MessageService, private apsPermissionService: ApsPermissionService, private ordersPagarMeService: OrdersPagarMeService, private fb: UntypedFormBuilder) {
		this.cardPagarMeCredit = new CardPagarMe();
		this.cardPagarMeDebit = new CardPagarMe();		
		this.itemPagarMe = new ItemPagarMe();	
		this.ordersPagarMeResponsePix = new OrdersPagarMeResponsePix();
	}

	ngOnInit() {
		this.apsPermissionService.permissionValidation(ApsPermitedScreen.screenContractImport);

		this.userform = this.fb.group({
			'number': new UntypedFormControl('', ),
			'holderName': new UntypedFormControl('', ),
			'expiration': new UntypedFormControl('', ),
			'cvv': new UntypedFormControl('', ),
			'numberDebit': new UntypedFormControl('', ),
			'holderNameDebit': new UntypedFormControl('', ),
			'expirationDebit': new UntypedFormControl('', ),
			'cvvDebit': new UntypedFormControl('', ),
			'pixAmount': new UntypedFormControl('', )
		});

		this.ordersPagarMe = new OrdersPagarMe();
		this.ordersPagarMeResponsePix = new OrdersPagarMeResponsePix();
	}

	onUpload(event: { files: File[] }): void {
		for(const file of event.files) {
			this.uploadedFiles.push(file);
		}

		this.messageService.add({severity:'success', summary: 'Success', detail: 'Message Content'});
	}

	bt(){
		this.showProgressBar = true;
		this.messageService.add({severity:'success', summary: 'Success', detail: 'Message Content'});
		this.showProgressBar = false;
	}

	confirmarExclusao(_lancamento: unknown): void {
		this.messageService.add({severity:'info', summary:'Informação', detail:'A exclusão não está disponível nesta tela.'});
	}

	validateCard(): void {
		this.ordersPagarMe = this.setOrdersPagarMe(this.CREDIT_CARD);
		this.ordersPagarMeService.save(this.ordersPagarMe).pipe(
			takeUntilDestroyed(this.destroyRef)
		).subscribe(() => {
			this.messageService.add({severity:'success', summary:'Sucesso', detail:'Pagamento autorizado com sucesso.'})
		}, (err) => {
			if (err.status === 402) {
				this.messageService.add({severity:'warn', summary:'Atenção', detail:'Pagamento recusado. Verifique os dados do cartão e tente novamente.'})
				return;
			}
			this.messageService.add({severity:'error', summary:'Erro', detail:'Pagamento não autorizado.'})
		});			
	} 
	
	validateDebitCard(): void {
		this.ordersPagarMe = this.setOrdersPagarMe(this.DEBIT_CARD);
		this.ordersPagarMeService.saveDebit(this.ordersPagarMe).pipe(
			takeUntilDestroyed(this.destroyRef)
		).subscribe(() => {
			this.messageService.add({severity:'success', summary:'Sucesso', detail:'Pagamento autorizado com sucesso.'})
		}, (err) => {
			if (err.status === 402) {
				this.messageService.add({severity:'warn', summary:'Atenção', detail:'Pagamento recusado. Verifique os dados do cartão e tente novamente.'})
				return;
			}
			this.messageService.add({severity:'error', summary:'Erro', detail:'Pagamento não autorizado.'})
		});			
	}
	
	validatePix(): OrdersPagarMeResponsePix {
		let chargePagarMeResponse = new ChargePagarMeResponse();				
		const ordersPagarMeResponsePix = this.ordersPagarMeResponsePix;

		this.ordersPagarMe = this.setOrdersPagarMe(this.PIX);
		this.ordersPagarMeService.savePix(this.ordersPagarMe).pipe(
			takeUntilDestroyed(this.destroyRef)
		).subscribe((response: OrdersPagarMeResponsePix) => {
			response.charges.forEach(function (value) {
				chargePagarMeResponse = (value as ChargePagarMeResponse);
				ordersPagarMeResponsePix.charges.push(chargePagarMeResponse);

			})			
			this.messageService.add({severity:'success', summary:'Sucesso', detail:'Aguardando Pagamento.'})
			
		}, (err) => {
			if (err.status === 402) {
				this.messageService.add({severity:'warn', summary:'Atenção', detail:'Pagamento recusado. Verifique os dados do cartão e tente novamente.'})
				return;
			}
			this.messageService.add({severity:'error', summary:'Erro', detail:'Pagamento não autorizado.'})
		});
		return ordersPagarMeResponsePix;
	} 	

	setOrdersPagarMe(type: string): OrdersPagarMe {
		const ordersPagarMe = new OrdersPagarMe();
		
		const itemPagarMe = new ItemPagarMe();
		itemPagarMe.amount = 2990.00;
		if (type === this.PIX ) {
			itemPagarMe.amount = this.itemPagarMe.amount;
		}
		itemPagarMe.description = "TERMO DE CONTRATAÇÃO - GARANTIA ESTENDIDA REDUZIDA";
		itemPagarMe.quantity = "1";
		itemPagarMe.code = 123;

		ordersPagarMe.items.push(itemPagarMe);

		const customerPagarMe = new CustomerPagarMe();
		customerPagarMe.name = "Tony Stark";
		customerPagarMe.email = "tony@stark.com";
		customerPagarMe.document = "03154435026"
		customerPagarMe.document_type = "CPF";
		customerPagarMe.type = "INDIVIDUAL";

		const addressPagarMe = new AddressPagarMe();
		addressPagarMe.line_1 = "QNB 2";
		addressPagarMe.zip_code = "72115020";		
		addressPagarMe.city = "Brasilia";
		addressPagarMe.state = "DF";
		addressPagarMe.country = "BR";

		customerPagarMe.address = addressPagarMe;

		const mobilePhonePagarMe = new MobilePhonePagarMe();
		mobilePhonePagarMe.country_code = "55";
		mobilePhonePagarMe.area_code = "61"; 
		mobilePhonePagarMe.number =  "61988776655"; 

		const phonesPagarMe = new PhonesPagarMe()
		phonesPagarMe.mobile_phone = mobilePhonePagarMe;
		customerPagarMe.phones = phonesPagarMe;
		ordersPagarMe.customer = customerPagarMe;
		
		if (type === this.CREDIT_CARD ) {
			this.cardPagarMeCredit.exp_month = this.setExpirationCard("M");
			this.cardPagarMeCredit.exp_year = this.setExpirationCard("Y");		
		}

		if (type === this.DEBIT_CARD ) {
			this.cardPagarMeDebit.exp_month = this.setExpirationDebitCard("M");
			this.cardPagarMeDebit.exp_year = this.setExpirationDebitCard("Y");		
		}

		const billingAdressPagarMe = new BillingAddressPagarMe();
		billingAdressPagarMe.line_1 = "QNB 2";
		billingAdressPagarMe.zip_code = "72115020";
		billingAdressPagarMe.city = "Brasilia"
		billingAdressPagarMe.state = "DF";
		billingAdressPagarMe.country = "BR";

		this.cardPagarMeCredit.billing_address = billingAdressPagarMe;

		if (type === this.CREDIT_CARD ) {
			const creditCardPagarMe = new CreditCardPagarMe();
			creditCardPagarMe.installments = 1;
			creditCardPagarMe.recurrence = false;
			creditCardPagarMe.statement_descriptor = "FORD PROTECT";
			creditCardPagarMe.card = this.cardPagarMeCredit;		

			const paymentPagarMe = new PaymentPagarMe();
			paymentPagarMe.payment_method = type;
			paymentPagarMe.credit_card = creditCardPagarMe;
			
			ordersPagarMe.payments.push(paymentPagarMe);
		}

		if (type === this.DEBIT_CARD ) {
			const debitCardPagarMe = new DebitCardPagarMe();
			debitCardPagarMe.installments = 1;
			debitCardPagarMe.recurrence = false;
			debitCardPagarMe.statement_descriptor = "FORD PROTECT";
			debitCardPagarMe.card = this.cardPagarMeDebit;		

			const paymentPagarMe = new PaymentPagarMe();
			paymentPagarMe.payment_method = type;
			paymentPagarMe.debit_card = debitCardPagarMe;
			
			ordersPagarMe.payments.push(paymentPagarMe);
		}

		if (type === this.PIX ) {
			const additionalInformation = new AdditionalInformationPagarMe();
			additionalInformation.name = "Quantidade";
			additionalInformation.value = "2";

			const pixPagarMe = new PixPagarMe();
			pixPagarMe.expires_in = "52134613";
			pixPagarMe.additional_information.push(additionalInformation);

			const paymentPagarMe = new PaymentPagarMe();
			paymentPagarMe.payment_method = type;
			paymentPagarMe.pix = pixPagarMe;
			
			ordersPagarMe.payments.push(paymentPagarMe);
		}		

		return ordersPagarMe;
	}		

	setExpirationCard(param: string): string {
		this.dataCard = [];
		if (this.cardPagarMeCredit.exp_year !== null) {
			this.dataCard = this.cardPagarMeCredit.exp_year.split("/", 2);
		}
		if (param === "M") {		
			return this.dataCard[0];
		}
		if (param === "Y") {
			return this.dataCard[1];
		}
		return "";
	}

	setExpirationDebitCard(param: string): string {
		this.dataCard = [];
		if (this.cardPagarMeDebit.exp_year !== null) {
			this.dataCard = this.cardPagarMeDebit.exp_year.split("/", 2);
		}
		if (param === "M") {		
			return this.dataCard[0];
		}
		if (param === "Y") {
			return this.dataCard[1];
		}
		return "";
	}	
}
